/**
 * FileDeleteRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileDeleteFailedErr } from './file_delete_failed_err'

/**
 * FileDeleteRes
 */
export interface FileDeleteRes {
  /** 成功删除的文件数量 */
  success?: number
  /** 失败的文件数量 */
  failed?: number
  /** 失败的文件列表 */
  failed_errors?: FileDeleteFailedErr[]
}

/**
 * FileDeleteRes Schema
 */
export const FileDeleteResSchema: SchemaDefinition = {
  properties: {
    success: {
      description: '成功删除的文件数量',
      format: 'int',
      type: 'integer',
      label: '成功删除的文件数量',
    },
    failed: {
      description: '失败的文件数量',
      format: 'int',
      type: 'integer',
      label: '失败的文件数量',
    },
    failed_errors: {
      description: '失败的文件列表',
      format: '[]handler.FileDeleteFailedErr',
      items: { $ref: 'FileDeleteFailedErr', description: '' },
      type: 'array',
      label: '失败的文件列表',
    },
  },
  type: 'object',
}
